<template>
    <div class="content-container-white">
        <ModuleHeader title="Rechnungen">
            <div><ul class="horizontal-list">
                <li>
                    <router-link class="icon-link" :to="{name: 'InvoiceAdd'}"><font-awesome-icon icon="plus" class="icon"/> Neu</router-link>
                </li>
            </ul></div>
        </ModuleHeader>

        <div class="container-fluid">
                <div class="loading" v-if="loading && !error">

            </div>

            <div v-if="error" class="error">
                {{ error }}
            </div>

            <div v-if="invoices" class="content">

                <b-tabs>
                    <b-tab title="Aktuelles Quartal">
                        <br>I'm the first fading tab
                    </b-tab>
                    <b-tab title="Offene" >
                        <br>I'm the second tab content
                    </b-tab>
                    <b-tab title="Alle" active>
                        <div class="mt-5">
                            <v-client-table :data="invoices" :columns="columns" :options="options">

                                <span slot="createDate" slot-scope="props" class="text-darker">{{props.row.createDate | moment('DD.MM.YYYY')}}</span>
                                <span slot="state" slot-scope="props" class="item-badge badge bg-secondary">{{props.row.state}}</span>

                                <div slot="action" slot-scope="props" >

                                    <table-edit-link :target="'InvoiceEdit'" :params="{id: props.row.id}"></table-edit-link>
                                    <table-edit-link :target="'InvoiceViewer'" :params="{id: props.row.id}" viewLink class="ml-2"></table-edit-link>
                                </div>

                                <vuetable-pagination-info
                                        info-template="Spanish text {from} to {to} of {total} records"
                                ></vuetable-pagination-info>
                            </v-client-table>
                        </div>
                    </b-tab>
                </b-tabs>
            </div>
        </div>
    </div>
</template>

<script>
    import ModuleHeader from "components/util/ModuleHeader";
    import TableEditLink from "components/util/TableEditLink";
    import firestore from "firedb/init";

    export default {
        name: "InvoiceDashboard",
        components: {ModuleHeader, TableEditLink},
        data: () => {
            return {
                loading: true,
                error: null,
                invoices: [],

                columns: ['number', 'state', 'customerName', 'projectName', 'createDate', 'amount', 'action'],
                options: {
                    skin: 'table table-hover data-table',
                    filterable: false
                },
            }
        },

        created () {
            // fetch the data when the view is created and the data is
            // already being observed
            this.fetchData()
        },

        methods: {
            fetchData() {
                this.error = this.invoices = null;
                this.loading = true;

                firestore.collection('invoice').get()
                    .then(snapshot => {

                        this.invoices = [];
                        snapshot.forEach(doc => {
                            let invoice = doc.data();
                            invoice.id = doc.id;

                            this.invoices.push(invoice);
                        });

                        this.loading = false;
                    })
                    .catch((e) => {
                        if (e.code === 'permission-denied') {
                            this.error = 'Berechtigungen fehlen';
                        } else {
                            this.error = 'Unerwarteter Fehler';
                        }
                    });
            },

            edit(id) {
                return `${this.$router.currentRoute.path}/edit/${id}`;
            },

            view(id) {
                return `${this.$router.currentRoute.path}/view/${id}`;
            }
        }
    }
</script>

<style scoped lang="scss">

    .badge {

        padding-top: 0.35rem;
        padding-bottom: 0.35rem;
    }

</style>